module.exports = __webpack_public_path__ + "img/yt_shorts.0065ffb4.png";